export default {
  title: 'Profil',
  fields: {
    name: {
      label: 'Navn',
      placeholder: 'Indtast restaurantens navn',
    },
    short_name: {
      label: 'Kort navn',
      placeholder: 'Indtast restaurantens korte navn',
      tooltip:
        'Nogle gange er restaurantens standardnavne meget lange og kan indeholde sekundære oplysninger, så i nogle tilfælde (f.eks. til kortere notifikationer) kræves en kortere version af navnet',
    },
    phone_number: {
      label: 'Telefonnummer',
      placeholder: 'Indtast restaurantens telefonnummer',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Indtast restaurantens e-mailadresse',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Brand-slug',
    },
    language: {
      label: 'Sprog',
      placeholder: 'Brug gruppens standard',
      tooltip:
        'Det sprog, kunderne ser i denne restaurants butik, og standarden for dens medarbejdere. Lad feltet stå tomt for at følge brandets sprog. Medarbejdere kan stadig vælge deres eget sprog til deres egen visning.',
    },
    sms_name: {
      label: 'SMS-navn',
      placeholder: 'SMS-visningsnavn',
    },
    instagram_link: {
      label: 'Instagram-link',
      placeholder: 'Indtast restaurantens Instagram-link',
    },
    website_link: {
      label: 'Link til hjemmeside',
      placeholder: 'Indtast restaurantens hjemmesidelink',
    },
    impressum_link: {
      label: 'Link til impressum',
      placeholder: 'Indtast restaurantens impressumlink',
    },
    timezone: {
      label: 'Tidszone',
      placeholder: 'Søg efter en by eller tidszone',
      tooltip:
        'Den tidszone, denne restaurant opererer i. Den styrer ordretidspunkter, åbningstider og planlagte ordretidspunkter. Den blev indstillet ud fra restaurantens adresse, da restauranten blev oprettet – ret den her, hvis den er forkert.',
    },
    time_format: {
      label: 'Tidsformat',
      placeholder: 'Brug landets standard',
      tooltip:
        'Hvordan tidspunkter vises for dit team i hele dashboardet og ordreportalen. Lad feltet stå tomt for at følge konventionen i restaurantens region.',
      options: {
        '12h': '12-timers (5:30 pm)',
        '24h': '24-timers (17:30)',
      },
    },
    primary_color: {
      label: 'Primær farve',
    },
    restaurant_type: {
      label: 'Restauranttype og servicemodel',
    },
    cuisine_types: {
      label: 'Madkategorier og køkkentyper',
    },
  },
  test_restaurant: {
    title: 'Testrestaurant',
    description:
      'Gør denne til din testrestaurant for at afprøve print, e-mails, ordrer og integrationer i produktion. Den fortsætter med at fungere som enhver anden restaurant og faktureres aldrig. Du kan have én testrestaurant.',
    description_test:
      'Dette er din testrestaurant. Den fungerer som enhver anden restaurant og faktureres aldrig. Kunde-e-mails og SMS om dens ordrer starter med [TEST].',
    mark: 'Markér som testrestaurant',
    remove: 'Fjern test-markering',
    slot_taken: 'Du har allerede en testrestaurant ({{name}}). Fjern test-markeringen fra din eksisterende først.',
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    info_updated: 'Indstillingerne er opdateret',
  },
};
